import { useState, useEffect } from 'react'

export function useCountdown(initialMinutes: number, initialSeconds: number) {
  const [time, setTime] = useState({
    minutes: initialMinutes,
    seconds: initialSeconds,
  })

  useEffect(() => {
    const timer = setInterval(() => {
      if (time.seconds > 0) {
        setTime((prev) => ({ ...prev, seconds: prev.seconds - 1 }))
      } else if (time.seconds === 0) {
        if (time.minutes === 0) {
          clearInterval(timer)
        } else {
          setTime((prev) => ({ minutes: prev.minutes - 1, seconds: 59 }))
        }
      }
    }, 1000)

    return () => clearInterval(timer)
  }, [time])

  return {
    minutes: time.minutes.toString().padStart(2, '0'),
    seconds: time.seconds.toString().padStart(2, '0'),
  }
}
